export default "__VITE_ASSET__ygzobQy3__"